import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCustomFieldDefinitionListVariables,
  PayrollCustomFieldDefinitionsResponse,
} from '../types';

export const listCustomFieldDefinitionsQuery = gql`
  query PayrollCustomFieldDefinitions($section: String, $pageSize: Int, $pageToken: String) {
    payrollCustomFieldDefinitions(section: $section, pageSize: $pageSize, pageToken: $pageToken) {
      definitions {
        id
        fieldKey
        label
        valueType
        origin
        isRequired
        enumValues
        usages
        section
        displayOrder
        accessPolicy
      }
      pageInfo {
        total
        nextPageToken
        hasNext
      }
    }
  }
`;

export const listCustomFieldDefinitions = (
  queryVariables: PayrollCustomFieldDefinitionListVariables,
) =>
  graphQLApi<PayrollCustomFieldDefinitionsResponse, PayrollCustomFieldDefinitionListVariables>({
    query: listCustomFieldDefinitionsQuery,
    queryVariables,
  });
